import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { createHistoryStorage } from '@snapask/common-components/dist/utils/history';

import configureStore from '../../store/configureStore';

class ProviderWithRouter extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    initialState: PropTypes.object,
    rootReducer: PropTypes.func, // eslint-disable-line react/require-default-props

    // for server side rendering usage only.
    store: PropTypes.object, // eslint-disable-line
    history: PropTypes.object.isRequired, // eslint-disable-line
  };

  static defaultProps = {
    initialState: {},
  };

  constructor(props) {
    super(props);

    const { initialState, rootReducer, history, store } = props;

    this.store =
      store ||
      configureStore(rootReducer, initialState, {
        history,
      });

    // TODO store.subscribe patch localStorage
    // Even we can use throttle function to optimize performance,
    // we still need to compare the object deeply.
    // Therefore, I prefer to use middleware to catch action type,
    // then do the necessary update.
    // if (__CLIENT__) {
    //   const reduxStore = this.store;
    //   reduxStore.subscribe(() => {
    //     const tutorial = reduxStore.getState().tutorial;
    //     console.log('tutorial', tutorial);
    //     // once the data change, then update localStorage
    //     // update localStorage per 2000ms
    //     // const stringifyTutorial = JSON.stringify(tutorial);
    //     // const updateLocalStorage = () => localStorage.setItem('tutorialSteps', stringifyTutorial);
    //     // throttle(updateLocalStorage, 2000);
    //   });
    // }
  }

  componentDidMount() {
    createHistoryStorage(this.props.history.location.pathname);
    this.props.history.listen(location => {
      createHistoryStorage(location.pathname);
    });
  }

  render() {
    return <Provider store={this.store}>{this.props.children}</Provider>;
  }
}

export default withRouter(ProviderWithRouter);



// WEBPACK FOOTER //
// ./app/containers/ProviderWithRouter/ProviderWithRouter.jsx